import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPermission } from '../utils/permissions';

const ProtectedRoute = ({ children, requiredPermission }) => {
    const isAuthAdmin = useSelector(state => state.adminAuth.adminLoggedIn);
    const adminData = useSelector(state => state.adminAuth.adminSessionData);

    if (!isAuthAdmin) {
        return <Navigate to="/login" replace />;
    }

    if (requiredPermission && !hasPermission(adminData?.permission, requiredPermission)) {
        return <Navigate to="/no-access" replace />;
    }

    return children;
};

export default ProtectedRoute;
